// extracted by mini-css-extract-plugin
module.exports = {"mentorsGrid":"styles_mentorsGrid__2zkTo"};